import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { List } from 'immutable';

import Popup from '../helpers/Popup';
import FormGroup from '../helpers/FormGroup';
import Checkbox from '../helpers/Checkbox';
import ErrorList from '../helpers/ErrorList';
import Select from '../helpers/Select';
import { Spinner } from '../helpers/Spinner';
import Button from '../helpers/Button';

/**
 * Change status popup components.
 *
 * @param props {Object}.
 * @param onUpdate {Function} To handle update button.
 * @param onClose {Function} To handle close button.
 * @param onChange {Function} To handle change of drop down list and checkboxes.
 * @param errors {Immutable.List} List of error.
 * @param status {String} Value of drop down list.
 * @param approved {Boolean} Value of checkbox approved.
 * @param passed {Boolean} Value of checkbox passed.
 * @param noResponse {Boolean} Value of checkbox no response.
 * @param showSpinner {Boolean} Show spinner icon.
 * @param statuses {Immutable.List} List of status.
 * @param disabled {Boolean} If set to true, will disabled update button.
 * @class
 */
const ChangeStatusPopup = props => {
  const {
    onUpdate,
    onClose,
    onChange,
    errors,
    status,
    approved,
    passed,
    noResponse,
    statuses,
    showSpinner,
    disabled,
  } = props;
  const header = 'Change All Status Codes';
  const footer = (
    <>
      <Button key="create" className="btn-primary" data-dismiss="modal" disabled={disabled} onClick={onUpdate}>
        Update {showSpinner ? <Spinner className="button" size="small" inline /> : null}
      </Button>
      <Button key="close" data-dismiss="modal" onClick={onClose}>
        Close
      </Button>
    </>
  );

  return (
    <Popup footer={footer} header={header} id="changeStatusPopup">
      <div className="row">
        <FormGroup className="col-xs-6">
          <Select
            id="change-statuses-status"
            label="Update Current Statuses"
            name="status"
            onChange={onChange}
            options={statuses}
            value={status}
            autoFocus
            showLabel
          />
        </FormGroup>
        <FormGroup className="col-xs-6 group-checkbox">
          <label className="field-label">Apply To</label>
          <Checkbox checked={approved} label="Approved" name="approved" onChange={onChange} />
          <Checkbox checked={passed} label="Passed" name="passed" onChange={onChange} />
          <Checkbox checked={noResponse} label="No Response" name="noResponse" onChange={onChange} />
        </FormGroup>
      </div>
      <ErrorList errors={errors} />
    </Popup>
  );
};

ChangeStatusPopup.propTypes = {
  approved: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  errors: PropTypes.instanceOf(List).isRequired,
  noResponse: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  passed: PropTypes.bool.isRequired,
  showSpinner: PropTypes.bool.isRequired,
  status: PropTypes.number.isRequired,
  statuses: PropTypes.instanceOf(List).isRequired,
};

export default memo(ChangeStatusPopup);
